var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.315 20.835L10.5 34.5L18 30L25.5 34.5L23.685 20.82M28.5 12C28.5 17.799 23.799 22.5 18 22.5C12.201 22.5 7.5 17.799 7.5 12C7.5 6.20101 12.201 1.5 18 1.5C23.799 1.5 28.5 6.20101 28.5 12Z",
    stroke: "url(#paint0_linear_1337_903)",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1337_903",
    x1: 7.19941,
    y1: 4.49971,
    x2: 28.7994,
    y2: 34.1997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F56D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63C2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardIcon);
export default __webpack_public_path__ + "static/media/award-icon.6b3c2ff4ce03c6506c2c618ab8d8f979.svg";
export { ForwardRef as ReactComponent };